import React, { Component } from 'react';

export default class RadarCaptionKeys extends Component {
  constructor(props) {
    super(props);

    this.state = {
      limits: [{lowerLimit: 0, upperLimit: this.props.captionKeysCount}],
    };
  }

  componentDidUpdate(prevProps, prevState) {
    // when pdf export is requested, an initial re-render alters the page width to match the pdf, then calculates page break limits and re-renders back to normal width
    if (prevProps.layoutMode !== this.props.layoutMode) {
      if (this.props.layoutMode === 'pdfRecalculate') {
        const { captionKeysList } = this.props;
        let count = 0;
        let limits = [];
        let lowerLimit = 0;
        let upperLimit;
        captionKeysList.forEach((sectionID, i) => {
          let rowHeight = 0;
          if (this[`competencyRow-${sectionID}`]) {
            rowHeight = this[`competencyRow-${sectionID}`].offsetHeight + 1;
          }
          if ((count + rowHeight) < 600) {
            count += rowHeight;
          } else {
            upperLimit = i;
            limits.push({lowerLimit, upperLimit});
            lowerLimit = i;
            count = rowHeight;
          }
        })
        limits.push({lowerLimit, upperLimit: captionKeysList.length});
        this.setState({ limits });
        this.props.updateCompetencyComparisonPDFExportPreRenderStatus();
      } 
    }
  }

  render() {
    const { captionKeysList, sectionDetails, pdfRequested, layoutMode } = this.props;
    const { limits } = this.state;
    return limits && limits.map((limitsObj, i) => {
      const { lowerLimit, upperLimit } = limitsObj;
      return (
        <div 
          key={i} 
          className={`mw-100 ${pdfRequested ? '' : 'mv5'} page-break`}
          style={{ width: layoutMode === 'pdfRecalculate' ? '158mm' : ''}}
        >
          <div className='flex justify-between flex-wrap mb5'>
            <div className='w-100 tl mt3'>
              <div>
                <h4 className='tl f5 lh-solid ma0'>
                  Chart Competency Keys{i > 0 ? ' (continued)' : ''}
                </h4>
              </div>
              <div className='bb b--light-silver flex pv2 mb1'>
                  <p className='w-20 ma0'>Key</p>
                  <p className='w-auto mw-80 ma0'>Competency Title</p>
              </div>
              <div>
                {captionKeysList.map((sectionID, i) => {
                  const {title, label} = sectionDetails[sectionID];
                  return ( i >= lowerLimit && i < upperLimit) && (
                    <div 
                      key={sectionID} 
                      className='flex pv1' 
                      style={{padding: '.2rem 0'}}
                      ref={(sectionRow) => {
                        this[`competencyRow-${sectionID}`] = sectionRow
                      }}
                    >
                      <p className='w-20 ma0' style={{minWidth: '20%'}}>{label}</p>
                      <p className='w-auto mw-80 ma0'>{title}</p>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      )
    })
  }
}

